export default __webpack_public_path__ + "static/media/file-icon.5583acaf.svg";